import React, { useCallback } from 'react';
import { Checkbox } from '@vtblife/uikit';
import classname from '@search/classname/src';
import './AgentFavoritesLikeItem.css';

const cn = classname.bind(null, 'AgentFavoritesLikeItem');

export interface IOfferLikeItem {
    isLike: boolean;
    name: string;
    onChangeLike: () => void;
}

export const AgentFavoritesLikeItem: React.FC<IOfferLikeItem> = ({ isLike, onChangeLike, name }) => {
    const handleChangeLike = useCallback(
        () => {
            onChangeLike();
        },
        [ onChangeLike ]
    );

    return (<div className={cn()}>
        <Checkbox block onChange={handleChangeLike} value={isLike}>{name}</Checkbox>
    </div>);
};

